(function () {
  'use strict';

  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/\u0131/g, 'i').replace(/\s+/g, ' ').trim();
  }

  function initialize() {
    var template = document.getElementById('tarot-database-search-template');
    var configuration = document.getElementById('tarot-database-search-config');
    var main = document.querySelector('main');
    if (!template || !configuration || !main || main.querySelector('[data-tdb-ready]')) return;
    var copy;
    try { copy = JSON.parse(configuration.textContent); } catch (error) { return; }
    var content = main.querySelector('.m-page-content') || main;
    var tables = Array.prototype.slice.call(content.querySelectorAll('table')).filter(function (table) {
      return table.tHead && table.tBodies.length && (table.tHead.rows[0].cells.length === 3 || table.tHead.rows[0].cells.length === 6);
    });
    var expected = [22, 14, 14, 14, 14];
    if (tables.length !== expected.length) return;
    if (tables.some(function (table, index) { return table.tHead.rows[0].cells.length !== (index === 0 ? 6 : 3); })) return;
    var sourceRows = tables.map(function (table) {
      return Array.prototype.slice.call(table.tBodies[0].rows);
    });
    if (sourceRows.some(function (rows, index) { return rows.length !== expected[index]; })) return;

    var panel = template.content.firstElementChild.cloneNode(true);
    panel.setAttribute('data-tdb-ready', '');
    var search = panel.querySelector('[data-tdb-search]');
    var suit = panel.querySelector('[data-tdb-suit]');
    var clear = panel.querySelector('[data-tdb-clear]');
    var status = panel.querySelector('[data-tdb-status]');
    var empty = panel.querySelector('[data-tdb-empty]');
    var list = panel.querySelector('[data-tdb-results]');
    var reference = panel.querySelector('[data-tdb-reference]');
    var referenceBody = panel.querySelector('[data-tdb-reference-body]');
    var records = [];

    tables.forEach(function (table, group) {
      var labels = group === 0 ? copy.majorColumns : copy.minorColumns;
      table.classList.add('tdb-reference-table');
      table.setAttribute('role', 'table');
      Array.prototype.forEach.call(table.tHead.rows[0].cells, function (cell, index) {
        if (!cell.id) cell.id = 'tdb-column-' + group + '-' + index;
        cell.setAttribute('scope', 'col');
      });
      sourceRows[group].forEach(function (row) {
        var values = Array.prototype.map.call(row.cells, function (cell, index) {
          cell.setAttribute('data-tdb-label', labels[index]);
          cell.setAttribute('headers', table.tHead.rows[0].cells[index].id);
          return cell.textContent.replace(/\s+/g, ' ').trim();
        });
        var nameColumn = group === 0 ? 1 : 0;
        var item = document.createElement('li');
        item.className = 'tdb-card';
        var detail = document.createElement('details');
        var summary = document.createElement('summary');
        var name = document.createElement('strong');
        name.className = 'tdb-card__name';
        name.textContent = values[nameColumn];
        var category = document.createElement('span');
        category.className = 'tdb-card__category';
        category.textContent = copy.suits[group];
        var preview = document.createElement('span');
        preview.className = 'tdb-card__preview';
        preview.textContent = values[group === 0 ? 4 : 2];
        summary.appendChild(name); summary.appendChild(category); summary.appendChild(preview);
        detail.appendChild(summary);
        var description = document.createElement('dl');
        values.forEach(function (value, index) {
          if (index === nameColumn) return;
          var field = document.createElement('div');
          var term = document.createElement('dt');
          var definition = document.createElement('dd');
          term.textContent = labels[index]; definition.textContent = value;
          field.appendChild(term); field.appendChild(definition); description.appendChild(field);
        });
        detail.appendChild(description); item.appendChild(detail); list.appendChild(item);
        records.push({ element: item, detail: detail, group: String(group), name: values[nameColumn], text: normalize(values.join(' ') + ' ' + copy.suits[group]) });
      });
    });

    // Move the existing reference block, including its headings and prose, into a
    // disclosure. Nothing is removed from the CMS or replaced with new meanings.
    var scope = tables[0].parentElement;
    while (scope && !tables.every(function (table) { return scope.contains(table); })) scope = scope.parentElement;
    if (!scope) return;
    function directChild(node) {
      while (node && node.parentElement !== scope) node = node.parentElement;
      return node;
    }
    var first = directChild(content.querySelector('#major-arcana') || tables[0]);
    var last = directChild(tables[tables.length - 1]);
    if (first && last && first !== last) {
      var node = first;
      while (node) {
        var next = node.nextSibling;
        referenceBody.appendChild(node);
        if (node === last) break;
        node = next;
      }
    } else {
      // A changed CMS structure still gets search; the original tables stay visible.
      reference.hidden = true;
    }
    var summaryBlock = scope.firstElementChild;
    scope.insertBefore(panel, summaryBlock ? summaryBlock.nextSibling : scope.firstChild);

    function filter() {
      var query = normalize(search.value);
      var terms = query.split(' ').filter(Boolean);
      var shown = 0;
      records.forEach(function (record) {
        var matches = (suit.value === 'all' || record.group === suit.value) && terms.every(function (term) { return record.text.indexOf(term) !== -1; });
        record.element.hidden = !matches;
        record.detail.open = matches && terms.length > 0;
        if (matches) shown += 1;
      });
      status.textContent = copy.status.replace('{shown}', String(shown)).replace('{total}', String(records.length));
      empty.hidden = shown !== 0;
      clear.disabled = !search.value && suit.value === 'all';
    }
    search.addEventListener('input', filter);
    suit.addEventListener('change', filter);
    clear.addEventListener('click', function () {
      search.value = ''; suit.value = 'all'; filter(); search.focus();
    });
    panel.querySelector('[data-tdb-empty-clear]').addEventListener('click', function () {
      clear.click();
    });

    // Only the exact reviewed English article keys and observed IDs can prefill.
    // Unknown handles and translated aliases leave all78 cards available.
    var params = new URLSearchParams(window.location.search);
    var context = params.get('article') || '';
    var source = Object.prototype.hasOwnProperty.call(copy.articleCards, context) ? copy.articleCards[context] : null;
    if (source && (!params.get('article_id') || params.get('article_id') === source.id) && records.some(function (record) { return normalize(record.name) === normalize(source.card); })) {
      search.value = source.card;
    }
    filter();

    function openReferenceAnchor() {
      var id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (error) { return; }
      var target = id ? document.getElementById(id) : null;
      if (target && referenceBody.contains(target)) reference.open = true;
    }
    window.addEventListener('hashchange', openReferenceAnchor);
    openReferenceAnchor();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
}());
